<mat-card>
  <mat-card-content>
    <div class="form-field-row">
      <mat-form-field class="item">
        <mat-label>Item Type</mat-label>
        <mat-select [(value)]="type">
          @for (filterType of filterTypes; track filterType) {
            <mat-option
              [value]="filterType">
              {{ filterType }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="item">
        <mat-label>Children Logic</mat-label>
        <mat-select [(value)]="childrenLogic">
          @for (operator of expressionOperators; track operator) {
            <mat-option
              [value]="operator">
              {{ operator }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="item">
        <mat-label>Peer Logic</mat-label>
        <mat-select [(value)]="peerLogic">
          @for (operator of expressionOperators; track operator) {
            <mat-option
              [value]="operator">
              {{ operator }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="spacer"></div>
      <button
        mat-icon-button
        color="warn"
        matTooltip="Remove Search Filter Item"
        (click)="handleItemRemove()">
        <mat-icon>playlist_remove</mat-icon>
      </button>
    </div>

    <gymfinder-search-filter-text
    [(languageText)]="text"></gymfinder-search-filter-text>

    <mat-checkbox [(ngModel)]="alwaysActive"
      >Check if the filter logic is always active</mat-checkbox
      >
      <div>
        <mat-checkbox [(ngModel)]="visible"
          >Check if the filter item is visible</mat-checkbox
          >
          @if (filters) {
            <gymfinder-filter-select
              [(filters)]="filters"
            [availableFilters]="availableFilters"></gymfinder-filter-select>
          }
        </div>
      </mat-card-content>
    </mat-card>
